import { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

/** Optical nudge onto the first line of the text the glyph labels. */
const BASE_OFFSET_Y = '0.125rem';

/** Shared by the severity glyph and the escalation urgency icon so they align. */
export const glyphLayoutSx = (extraOffsetY?: string): SystemStyleObject<Theme> => ({
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
  marginTop: extraOffsetY ? `calc(${BASE_OFFSET_Y} + ${extraOffsetY})` : BASE_OFFSET_Y,
});
